import React from 'react';
import styles from './no-match-message.scss';

const NoMatchMessage = () => (
  <div className={styles.noMatchMessage}>
    <div>{"Oops! We couldn't find a match."}</div>
    <div>{'Please try again.'}</div>
  </div>
);

export default NoMatchMessage;
